<template>
  <el-select v-model="value" @change="change"
             filterable
             clearable
             :loading="loading"
             :remote-method="getLinkName"
              placeholder="请选择广告主应用链接">
    <el-option v-for="item in linkNameOptions" :key="item.linkId" :label="item.linkName"
               :value="item.linkId" />
  </el-select>
</template>

<script>

import {getLinkName} from "@/api/manage/link/link";

export default {
  props: {
    dspId: {
      type: [Number],
      default: undefined
    },
    modelValue: [String, Number]
  },
  emits: ['update:modelValue'],
  data () {
    return {
      linkNameOptions: [],
      value: undefined,
      loading: false
    }
  },
  created() {
    console.log('created' + this.loading)
    if(this.linkNameOptions.length === 0){
      this.getLinkName()
    }
  },
  watch: {
    dspId: {
      handler(newVal) {
        console.log('dspId' + this.loading)
        this.$emit('update:modelValue', '')
        this.getLinkName()
      },
      immediate: true
    },
    modelValue: {
      handler(newVal) {
        console.log('modelValue' + this.loading)
        if (this.value === newVal) return
        if(this.linkNameOptions.length === 0){
          this.getLinkName()
        }
        this.value = newVal
      },
      immediate: true // 立即执行回调函数
    }
  },
  methods: {
    getLinkName () {
      if(!this.loading){
        getLinkName({ dspId: this.dspId }).then(res => {
          if (res.code === 200) {
            this.linkNameOptions = res.data
          }
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    change (item) {
      this.$emit('update:modelValue', item)
    }
  }
}
</script>

<style scoped>

</style>
